var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('backlink'),_vm._v(" "),_c('h1',[_vm._v("Environnements de stockage")]),_vm._v(" "),_c('AdminTable',{attrs:{"config":_vm.config,"options":_vm.options}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-370ba9d6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StorageEnvironment/StorageEnvironmentList.vue
// module id = 830
// module chunks = 0